export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const products = ['Jaggery', 'Textiles', 'Dried Mushrooms', 'Black Pepper', 'Turmeric'];

  return (
    <footer className="bg-gray-900 text-white mt-10">
      <div className="max-w-[1400px] mx-auto px-8 lg:px-16 py-14 lg:py-16">
        {/* Upper Footer - Four Column Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Column 1 - Brand */}
          <div className="lg:col-span-1">
            <img
              src="https://storage.readdy-site.link/project_files/21695a36-5064-423b-bac4-4ae2cbbe995a/7cfdc017-30df-42cc-821c-5d12781088e8_WhatsApp_Image_2026-03-23_at_9.17.45_AM-removebg-preview.png?v=3e6ee1f58e544bf931b71c33a97beab1"
              alt="JB GlobeX Logo"
              className="h-14 w-auto mb-4 object-contain"
            />
            <p className="text-gray-400 text-sm mb-4">
              Premium Quality Products
            </p>
            <p className="text-gray-500 text-sm leading-relaxed mb-6">
              Delivering premium agricultural and textile products from India to global markets.
            </p>
            {/* Social Media */}
            <div className="flex space-x-3">
              <a
                href="https://www.facebook.com/profile.php?id=61578657247835"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 border border-gray-700 rounded-full flex items-center justify-center hover:border-teal-600 hover:text-teal-600 transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill"></i>
              </a>
              <a
                href="https://x.com/JB_GlobeX"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 border border-gray-700 rounded-full flex items-center justify-center hover:border-teal-600 hover:text-teal-600 transition-colors cursor-pointer"
              >
                <i className="ri-twitter-x-fill"></i>
              </a>
              <a
                href="https://www.linkedin.com/in/jb-globex-2bb1983b9"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 border border-gray-700 rounded-full flex items-center justify-center hover:border-teal-600 hover:text-teal-600 transition-colors cursor-pointer"
              >
                <i className="ri-linkedin-fill"></i>
              </a>
              <a
                href="https://www.instagram.com/jb_globex?igsh=ZDY3c2s2N3UyZmt1"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 border border-gray-700 rounded-full flex items-center justify-center hover:border-teal-600 hover:text-teal-600 transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line"></i>
              </a>
            </div>
          </div>

          {/* Column 2 - Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('home')}
                  className="text-gray-400 hover:text-white hover:underline transition-colors text-sm cursor-pointer whitespace-nowrap"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-gray-400 hover:text-white hover:underline transition-colors text-sm cursor-pointer whitespace-nowrap"
                >
                  About
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('products')}
                  className="text-gray-400 hover:text-white hover:underline transition-colors text-sm cursor-pointer whitespace-nowrap"
                >
                  Products
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('quality')}
                  className="text-gray-400 hover:text-white hover:underline transition-colors text-sm cursor-pointer whitespace-nowrap"
                >
                  Quality
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('certifications')}
                  className="text-gray-400 hover:text-white hover:underline transition-colors text-sm cursor-pointer whitespace-nowrap"
                >
                  Certifications
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-400 hover:text-white hover:underline transition-colors text-sm cursor-pointer whitespace-nowrap"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Column 3 - Products */}
          <div>
            <h3 className="text-lg font-bold mb-6">Our Products</h3>
            <ul className="space-y-3">
              {products.map((product, index) => (
                <li key={index}>
                  <button
                    onClick={() => scrollToSection('products')}
                    className="text-gray-400 hover:text-white hover:translate-x-1 transition-all text-sm cursor-pointer whitespace-nowrap"
                  >
                    {product}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 4 - Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-6">Get In Touch</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <i className="ri-map-pin-line text-teal-600 text-lg mt-1 shrink-0"></i>
                <span className="text-gray-400 text-sm">
                  1st Block, Ganeshpuram, Robertsonpet,<br />
                  Kolar Gold Fields, Karnataka – 563122, India
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <i className="ri-phone-line text-teal-600 text-lg shrink-0"></i>
                <div className="flex flex-col space-y-1">
                  <a href="tel:+919743475615" className="text-gray-400 hover:text-white text-sm cursor-pointer whitespace-nowrap">
                    +91 9743475615
                  </a>
                </div>
              </li>
              <li className="flex items-center space-x-3">
                <i className="ri-mail-line text-teal-600 text-lg shrink-0"></i>
                <a href="mailto:info@jbglobex.com" className="text-gray-400 hover:text-white text-sm cursor-pointer">
                  info@jbglobex.com
                </a>
              </li>
            </ul>
            <a
              href="https://wa.me/919743475615"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-6 inline-flex items-center space-x-2 px-6 py-3 bg-[#25D366] text-white rounded-full hover:bg-[#20BA5A] transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-xl"></i>
              <span className="font-medium">WhatsApp Us</span>
            </a>
          </div>
        </div>

        {/* Lower Footer - Copyright Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-500 text-sm">
              © 2025 JB GlobeX. All rights reserved.
            </p>
            <div className="flex items-center space-x-2 text-gray-500 text-sm">
              <span>Made in India</span>
              <span className="text-lg">🇮🇳</span>
            </div>
            <div className="flex space-x-4 text-gray-500 text-sm">
              <a href="#" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                Privacy Policy
              </a>
              <span>|</span>
              <a href="#" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
